interface StatisticsCardsProps {
  totalVolume: number;
  totalRebate: number;
  pendingRebate: number;
  formatCurrency: (amount: number) => string;
  labels: {
    totalVolume: string;
    totalRebate: string;
    pendingRebate: string;
  };
}

const StatisticsCards = ({ totalVolume, totalRebate, pendingRebate, formatCurrency, labels }: StatisticsCardsProps) => {
  const stats = [
    {
      label: labels.totalVolume,
      value: formatCurrency(totalVolume),
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
        </svg>
      ),
      gradient: 'from-blue-500 to-cyan-500',
    },
    {
      label: labels.totalRebate,
      value: formatCurrency(totalRebate),
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      gradient: 'from-primary to-yellow-500',
    },
    {
      label: labels.pendingRebate,
      value: formatCurrency(pendingRebate),
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      gradient: 'from-orange-500 to-red-500',
    },
  ];

  return (
    <div className="grid grid-cols-3 gap-3 mb-6">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-tg-secondary rounded-xl p-4 text-center border border-gray-800 hover:border-primary/50 hover:bg-[#2a2a2a] hover:scale-105 hover:shadow-lg hover:shadow-primary/20 transition-all duration-300 cursor-pointer"
        >
          <div className="flex items-center justify-center mb-2">
            <div className={`w-8 h-8 rounded-lg bg-gradient-to-br ${stat.gradient} flex items-center justify-center text-white shadow-md`}>
              {stat.icon}
            </div>
          </div>
          <div className="text-xs text-tg-hint mb-1">{stat.label}</div>
          <div className="text-base font-bold text-primary">{stat.value}</div>
        </div>
      ))}
    </div>
  );
};

export default StatisticsCards;
